import React, { useState } from "react";
import SbEditable from "storyblok-react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HeroSlide from './HeroSlide';

const Hero = ({ blok }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    beforeChange: (current, next) => setCurrentIndex(next),
    appendDots: (dots) => {
      return (
        <div>
          <ul className="flex flex-col sm:flex-row absolute mt-[-110px] sm:mt-[-75px] left-6 sm:left-16">
            {dots.map((item, index) => {
              return (
                <li
                  className="!m-[5px] sm:!m-[5px] !h-[6px] sm:!h-[10px] !w-[6px] sm:!w-[10px]"
                  key={index}
                >
                  {item.props.children}
                </li>
              );
            })}
          </ul>
        </div>
      );
    },
    customPaging: (i) => (
      <div
        className={`relative w-full h-full transition-colors duration-500 ${
          i === currentIndex ? "bg-red" : "bg-white"
        }`}
      ></div>
    ),
  };

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative overflow-hidden">
        <Slider {...settings}>
          {blok.items.map((item) => (
            <HeroSlide blok={item} key={item._uid}/>
          ))}
        </Slider>
      </div>
    </SbEditable>
  );
};

export default Hero;
